import * as React from 'react';
import { BootstrapOptions } from 'owa-bootstrap';
import { bootstrap } from 'owa-bootstrap/lib/bootstrap';
import { registerBootstrapOptions } from './optionsRegistry';
import AppModule from './components/AppModule';
import { initializeModule } from './actions/updateModule';

export async function appBootstrap(options: BootstrapOptions) {
    initializeModule(options.appModuleProps!.module);
    registerBootstrapOptions(options);
    const suiteWrapper = options.strategies!.suiteWrapper;
    const SuiteWrapper = suiteWrapper ? await suiteWrapper.import() : undefined;
    const wrapSuiteHeader = SuiteWrapper
        ? suiteHeader => <SuiteWrapper suiteHeader={suiteHeader} />
        : undefined;
    options.renderMainComponent = () => <AppModule wrapSuiteHeader={wrapSuiteHeader} />;
    return bootstrap(options);
}
